document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('[data-slideshow]');

  slideshows.forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-slideshow-slide]'));
    const paginationButtons = Array.from(slideshow.querySelectorAll('[data-slide-button]'));

    // Funktion zur Aktualisierung der Folienzustände
    const updateSlides = (activeIndex) => {
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;

        // Aktualisieren von aria-hidden auf dem Foliencontainer
        slide.setAttribute('aria-hidden', !isActive);

        // Alle fokussierbaren Elemente innerhalb der Folie finden
        const focusableElements = slide.querySelectorAll('a, button, input, textarea, select, [tabindex]');

        focusableElements.forEach((el) => {
          if (isActive) {
            el.removeAttribute('tabindex');
            el.removeAttribute('aria-hidden');
          } else {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-hidden', 'true');
          }
        });
      });

      // Aktualisieren der Paginierungsschaltflächen
      paginationButtons.forEach((button, index) => {
        const isActive = index === activeIndex;
        button.setAttribute('aria-selected', isActive);
        button.setAttribute('aria-hidden', !isActive);
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    };

    // Initiale Aktualisierung
    let currentSlideIndex = 0;
    updateSlides(currentSlideIndex);

    // Event-Listener für Folienwechsel
    paginationButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const slideIndex = parseInt(button.getAttribute('data-slide-button'), 10);
        currentSlideIndex = slideIndex;
        updateSlides(currentSlideIndex);
      });
    });

    // Autoplay-Funktionalität (falls aktiviert)
    const autoplayEnabled = slideshow.getAttribute('data-autoplay') === 'true';
    if (autoplayEnabled) {
      const slideInterval = parseInt(slideshow.getAttribute('data-autoplay-speed'), 10) || 5000;

      setInterval(() => {
        currentSlideIndex = (currentSlideIndex + 1) % slides.length;
        updateSlides(currentSlideIndex);
      }, slideInterval);
    }
  });
});